/** @jsxImportSource theme-ui @jsxRuntime classic */
import React, { useMemo } from 'react';
import { WideCta, Container, Section } from '@tishman/components';
import invariant from 'invariant';

import type { ComponentPropsWithoutRef } from 'react';

const StoryWideCtaBlock = (
  props: { data: Queries.SanityStoryQuery } & ComponentPropsWithoutRef<
    typeof Section
  >,
): React.JSX.Element => {
  const { storyJson } = props.data;

  invariant(storyJson, 'Story JSON data is required!');

  const storyWideCtaProps = useMemo(
    () => ({
      title: storyJson.wideCta.title,
      caption: storyJson.wideCta.caption,
      link: storyJson.wideCta.link,
    }),
    [storyJson],
  );

  return (
    storyWideCtaProps && (
      <Section data-section="StoryWideCta" {...props}>
        <Container sx={{ py: [5, null, 8] }}>
          <WideCta {...storyWideCtaProps} />
        </Container>
      </Section>
    )
  );
};

export default StoryWideCtaBlock;
